import { Stack, Switch, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  readonlyMode: boolean;
}

export default function ToolTipItem({ settings, readonlyMode }: Props) {
  const showTooltip = isShowToolTip(settings);
  const dispatch = useAppDispatch();
  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Show Tooltip</Typography>
      <HorizontalFill />
      <Switch
        checked={showTooltip}
        disabled={readonlyMode}
        onChange={(_, value) => dispatch(fieldsStateActions.updateSettings({ settings: { showTooltip: value } }))}
      />
    </Stack>
  );
}

function isShowToolTip(settings: ChartStyleSettings) {
  return settings?.showTooltip === true;
}
